
<!-- Search and Filter -->
<div class="d-flex align-items-center flex-wrap justify-content-between" style="margin-top: 24px; margin-left: 44px; margin-right: 24px; gap: 12px;">
    <div class="d-flex align-items-center flex-wrap" style="gap: 12px;">
        <div class="input-group form-password-toggle d-flex" style="width: 300px;">
            <input
                    type="text"
                    [(ngModel)]="searchTerm"  (ngModelChange)="onSearch()"
                    class="form-control"
                    placeholder="Recherche par mot clé"
                    aria-label="Search..."
                    aria-describedby="basic-addon-search1"
            />
            <div class="input-group-append">
                <span class="input-group-text" id="basic-addon-search1" style="color: black;"><i data-feather="search" [size]="20"></i></span>
            </div>
        </div>
        <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
            <span data-feather="filter"></span>
        </button>
        <!-- Active Filters Chips -->
        <div class="d-flex align-items-center flex-wrap" style="gap: 8px;" *ngIf="getActiveFilters().length > 0">
            <div *ngFor="let filter of getActiveFilters(); trackBy: trackByFilterKey" class="filter-chip">
                <span class="filter-chip-label">{{ filter.label }}:</span>
                <span class="filter-chip-value">{{ filter.value }}</span>
                <button type="button" class="filter-chip-close" (click)="removeFilter(filter.key); $event.stopPropagation(); $event.preventDefault()" aria-label="Supprimer le filtre">
                    <i data-feather="x" [size]="14"></i>
                </button>
            </div>
        </div>
    </div>
    <!-- Filter Panel -->
    <div #filterPanel class="card filter-sidebar length" *ngIf="showFilter" style="width: 320px;">
        <div class="card-header d-flex justify-content-between align-items-center" style="margin-top: 2px; ">
            <h4 class="card-title mb-0">Filtres</h4>
            <button class="btn btn-sm btn-icon btn-light" (click)="toggleFilter()" aria-label="X">
                X <i class="bx bx-x"></i>
            </button>
        </div>
        <div class="card-body d-flex flex-column " style="height: 350px ; box-shadow: 2px 4px 8px rgba(47, 43, 61, 0.14);">
            <div class="flex-grow-1 overflow-auto p-1">
                <div class="mb-1">
                    <label class="form-label">Label</label>
                    <div class="d-flex w-100">
                        <input type="text" class="form-control" placeholder="Entrez un label" [(ngModel)]="filters.label" />
                    </div>
                </div>

                <div class="mb-1">
                    <label class="form-label">Valeur en stock</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control" style="width: 60px; margin-right: 8px;" [(ngModel)]="filters.valeurOperator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.valeur" placeholder="Montant" />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Prix d'achat</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control" style="width: 60px; margin-right: 8px;" [(ngModel)]="filters.prixAchatOperator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.prixAchat" placeholder="Montant" />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Prix de vente</label>
                    <div class="d-flex w-100">
                        <select class="form-select form-control" style="width: 60px; margin-right: 8px;" [(ngModel)]="filters.prixVenteOperator">
                            <option value="=">=</option>
                            <option value=">">></option>
                            <option value="<"><</option>
                        </select>
                        <input type="number" class="form-control flex-grow-1" [(ngModel)]="filters.prixVente" placeholder="Montant" />
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">Stock</label>
                    <div class="d-flex w-100">
                        <input type="number" class="form-control flex-grow-1" placeholder="Entrez un stock" [(ngModel)]="filters.stock" />
                    </div>
                </div>
            </div>
            <div class="pt-2 d-flex justify-content-end gap-1">
                <button class="btn btn-outline-secondary" (click)="resetFilters()" style="margin-right: 15px;">Réinitialiser</button>
                <button class="btn btn-primary" (click)="applyFilters()">Appliquer</button>
            </div>
        </div>
    </div>

</div>
<div style=" border-bottom: 1px solid #eee; margin-top: 24px; margin-bottom: 10px"></div>

<div class="table-responsive" style="height: 620px">
    <table class="table table-hover">
        <thead class=" custom-thead" >
        <tr  class="align-middle" style="color: #2F2B3DE5; font-size: 13px">
            <th>RÉFÉRENCE</th>
            <th>LABEL</th>
            <th>VALEUR EN STOCK</th>
            <th>PRIX D'ACHAT</th>
            <th>PRIX DE VENTE</th>
            <th>STOCK</th>
            <th>ACTION</th>
        </tr>
        </thead>
        <tbody style="color: #2F2B3DE5; font-size: 15px">
        <tr *ngIf="isLoading">
            <td [attr.colspan]="7" style="text-align: center; padding: 2rem;">
                <div class="spinner-border" role="status" style="color: rgba(19, 74, 211, 1)">
                    <span class="sr-only"></span>
                </div>
            </td>
        </tr>
        <tr *ngFor="let item of paginatedData; trackBy: trackByEtatRow">
            <td class="ref" (click)="detail(item.id)">#{{ item.ref_interne }}</td>
            <td>{{ item.nom }}</td>
            <td>{{ item.valeur_en_stock | number : '1.2-2' }}</td>
            <td>{{ item.prix_unitaires | number : '1.2-2' }}</td>
            <td>{{ item.prixVente != null ? (item.prixVente | number : '1.2-2') : '—' }}</td>
            <td>{{ item.quantity | number : '1.2-2' }}</td>
            <td>
                <div class="d-flex align-items-center ">
                    <button
                        type="button"
                        class="etat-btn-eye"
                        (click)="detail(item.id); $event.stopPropagation()"
                        aria-label="Voir le détail du produit"
                    >
                        <i data-feather="eye" [size]="20"></i>
                    </button>
                </div>

            </td>
        </tr>
        <tr *ngIf="!isLoading && paginatedData.length === 0">
            <td [attr.colspan]="7" style="text-align: center; padding: 2rem; font-weight: 500; color: #6e6e6e;">
                Pas de données à afficher
            </td>
        </tr>
        </tbody>
    </table>
</div>

<div class="row mt-3">
    <div class="col-md-6 col-12">
        <div class="d-flex justify-content-between align-items-center m-1">
            <label class="d-flex align-items-center" style="font-size: 15px;">
                Afficher
                <select class="form-control mx-25" [(ngModel)]="basicSelectedOption" (ngModelChange)="updatePagination()">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </label>
        </div>
    </div>
    <div class="col-md-6 text-end">
        <div class="d-flex flex-wrap justify-content-end gap-2">
            <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(1)">«</div>
            <div class="page-box" [class.disabled]="currentPage === 1" (click)="currentPage > 1 && changePage(currentPage - 1)">‹</div>
            <div *ngFor="let page of pages" class="page-box" [class.active]="page === currentPage" (click)="changePage(page)">{{ page }}</div>
            <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(currentPage + 1)">›</div>
            <div class="page-box" [class.disabled]="currentPage === totalPages" (click)="currentPage < totalPages && changePage(totalPages)">»</div>
        </div>
    </div>
</div>


